import _ from 'lodash';
/**
 * Takes an array of arrays of objects containing 'label' and 'qty' keys
 * and returns a dictionary where the keys are the unique 'label' values and
 * the values are the sums of the corresponding 'qty' values across all the input arrays.
 *
 * @param {Array} data - The input array of arrays of objects containing 'label' and 'qty' keys
 * @returns {Object} - A dictionary where the keys are the unique 'label' values and the values are the sums
 * of the corresponding 'qty' values
 */
export const mapProjectAnalyticsAggregations = (data) => {
  if (!_.isEmpty(data)) {
    const result = {};

    Object.entries(data).forEach(([key, value]) => {
      result[key] = {};

      if (_.isArray(value.buckets)) {
        value.buckets.forEach(({ key: label, docCount }) => {
          if (label) { result[key][label] = docCount; }
        });
      }
    });

    return result;
  }
  return {};
};

export const mapProjectAggregations = (aggs, globalAggs) => {
  if (!_.isEmpty(aggs) && !_.isEmpty(globalAggs)) {
    const result = {};

    Object.entries(globalAggs).forEach(([key, value]) => {
      result[key] = {};

      if (_.isArray(value.buckets)) {
        value.buckets.forEach(({ key: label }) => {
          if (label) { result[key][label] = 0; }
        });
      }
    });

    Object.entries(aggs).forEach(([key, value]) => {
      if (_.isArray(value.buckets)) {
        value.buckets.forEach(({ key: label, docCount }) => {
          if (label) {
            result[key][label] = docCount;
          }
        });
      }
    });
    return result;
  }
  return {};
};

export const mapProjectDemographics = (demographics) => {
  if (!_.isEmpty(demographics)) {
    const result = {};

    Object.entries(demographics).forEach(([key, value]) => {
      if (key === '__typename' || _.isEmpty(key)) return;
      result[key] = {};

      const parsedValue = JSON.parse(value);
      Object.keys(parsedValue).forEach((label) => {
        if (_.isEmpty(label)) return;
        result[key.toString()][label] = parsedValue[label];
      });
    });

    return result;
  }
  return {};
};
